import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {ReactBaseComponent} from '../../../../react/base/react-base.component';
import {WorkflowFetchCopyCreate} from '../../../../react/workflow/fetch/workflow-fetch-copy-create';

const containerElementName = 'reactDeliveryCreateFetchSplitModalContainer';

@Component({
    selector: 'delivery-fetch-copy-create',
    template: `<div #${containerElementName}></div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DeliveryFetchCopyCreateComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() workflowId: number;
  @Input() fetchId: number;
  @Output() reloadList: EventEmitter<void> = new EventEmitter<void>();

  constructor(private ngZone: NgZone) {
    super();
  }

  reload(): void {
    this.ngZone.run(() => {
      this.reloadList.emit();
    });
  }

  protected override renderComponent() {
    return <WorkflowFetchCopyCreate workflowId={this.workflowId}
                                    fetchId={this.fetchId}
                                    reload={() => this.reload()}/>;
  }
}
